/** User-facing copy when `/system/client/config?domainKey=<hostname>` cannot be loaded. */
export const CLIENT_CONFIG_LOAD_ERROR_MESSAGE =
    'Something went wrong, Please contact Site Administrator or try reloading after some time.';

/** Sidebar menu tree when client config is not yet loaded. */
export const FALLBACK_MENU_KEY = 'instantUpdate';

/** Built-in SVG logos when client config is not yet loaded. */
export const FALLBACK_BRAND_LOGO_NAME = 'IUSiteLogo';
export const FALLBACK_MINIFIED_BRAND_LOGO_NAME = 'MinifiedIUSiteLogo';

/** Contact defaults when client config is not yet loaded. */
export const FALLBACK_SUPPORT_EMAIL = 'support@instantupdate.ai';
export const FALLBACK_CONTACT_EMAIL = 'sales@instantupdate.ai';
export const FALLBACK_CONTACT_PHONE = '+447837616656';

/** Dictionary bucket hostname when client config is unavailable (prod-tier IU labels). */
export const FALLBACK_DICTIONARY_HOST = 'my.instantupdate.ai';
